/**
 * Handle user clicking outside specified element with an option exclusion
 */

import {useEffect} from 'react';
import {TooltipAndOverlayIDs} from '../v2/components/detailed-tooltip/TooltipLibrary';

export function useHandleClickOutside(ref, callback, exclusion, exclusionId, excludedOverlay) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (excludedOverlay === TooltipAndOverlayIDs.COLLECTION) {
        return;
      }
      
      if (exclusion?.current) {
        if (ref.current && !ref.current.contains(event.target) && !exclusion.current.contains(event.target)) {
          callback(event);
        }
      } else if (exclusionId) {
        if (ref.current && !ref.current.contains(event.target)
          && event.target?.getElementById === 'function' && !event.target?.getElementById(exclusionId)) {
          callback(event);
        }
      } else if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, exclusion]);
}

export default useHandleClickOutside;
